<template>
  <div
    v-loading.fullscreen="loading"
    class="app-main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
  >
    <div class="tabs-container">
      <div v-if="$store.getters.enableFrontEndPlugin">
        <micro-app
          name="child-ar-WriteOffStatus-Query-ReleaseManagement"
          :url="$store.getters.frontEndPluginUrl+'/arWriteOffStatusQuery'"
          router-mode="pure"
          destroy
          @datachange="arWriteOffStatusQueryDataChange"
        />
      </div>
      <el-tabs v-if="showView" v-model="activeTabName" type="card" style="width:100%;height: 100%">
        <el-tab-pane v-if="singleReleaseVerifyView" :lazy="true" :label="$t('CargoMsg.Cargo_MBLReleaseReview')" name="singleReleaseVerifyView" style="width:100%;height: 100%">
          <single-release-verify-view
            tab-name="singleReleaseVerifyView"
            :tab-title="$t('CargoMsg.Cargo_MBLReleaseReview')"
            :ar-write-off-status-query-search="arWriteOffStatusQuerySearch"
            :ar-write-off-status-query-column="arWriteOffStatusQueryColumn"
          />
        </el-tab-pane>
        <el-tab-pane v-if="singleReleaseView" :lazy="true" :label="$t('CargoMsg.Cargo_MBLReleaseManagement')" name="singleReleaseView" style="width:100%;height: 100%">
          <single-release-view
            tab-name="singleReleaseView"
            :tab-title="$t('CargoMsg.Cargo_MBLReleaseManagement')"
            :ar-write-off-status-query-search="arWriteOffStatusQuerySearch"
            :ar-write-off-status-query-column="arWriteOffStatusQueryColumn"
          />
        </el-tab-pane>
        <el-tab-pane v-if="singleReleaseVerifyViewHbl" :lazy="true" :label="$t('CargoMsg.Cargo_HBLReleaseReview')" name="singleReleaseVerifyViewHbl" style="width:100%;height: 100%">
          <single-release-verify-view-hbl
            tab-name="singleReleaseVerifyViewHbl"
            :tab-title="$t('CargoMsg.Cargo_HBLReleaseReview')"
            :ar-write-off-status-query-search="arWriteOffStatusQuerySearch"
            :ar-write-off-status-query-column="arWriteOffStatusQueryColumn"
          />
        </el-tab-pane>
        <el-tab-pane v-if="hblSingleReleaseView" :lazy="true" :label="$t('CargoMsg.Cargo_HBLReleaseManagement')" name="hblSingleReleaseView" style="width:100%;height: 100%">
          <hbl-single-release-view
            tab-name="hblSingleReleaseView"
            :tab-title="$t('CargoMsg.Cargo_HBLReleaseManagement')"
            :ar-write-off-status-query-search="arWriteOffStatusQuerySearch"
            :ar-write-off-status-query-column="arWriteOffStatusQueryColumn"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

import singleReleaseVerifyView from '@/views/cargo/v0/Clearing/components/releaseControl/singleReleaseVerifyView'
import singleReleaseView from '@/views/cargo/v0/Clearing/components/releaseControl/singleReleaseView'
import SingleReleaseVerifyViewHbl from '@/views/cargo/v0/Clearing/components/releaseControl/singleReleaseVerifyViewHbl'
import hblSingleReleaseView from '@/views/cargo/v0/Clearing/components/releaseControl/hblSingleReleaseView'
import checkPermission from '@/utils/permission'
import microApp from '@micro-zoe/micro-app'

export default {
  name: 'ReleaseManagement',
  components: { singleReleaseVerifyView, singleReleaseView, SingleReleaseVerifyViewHbl, hblSingleReleaseView },
  data() {
    return {
      loading: true,
      activeTabName: 'singleReleaseVerifyView',
      singleReleaseVerifyView: false,
      singleReleaseView: false,
      singleReleaseVerifyViewHbl: false,
      hblSingleReleaseView: false,
      showView: true,
      arWriteOffStatusQuery: { // 应收核销状态查询条件/显示列
        viewSource: 'ReleaseManagement',
        searchItem: false, // 查询条件
        columnItem: false // 显示列
      },
      arWriteOffStatusQuerySearch: false,
      arWriteOffStatusQueryColumn: false
    }
  },
  async created() {
    this.loading = false
    this.singleReleaseVerifyView = checkPermission(['tab_SingleRelease_tabSingleReleaseVerify'])
    this.singleReleaseView = checkPermission(['tab_SingleRelease_tabSingleRelease'])
    this.singleReleaseVerifyViewHbl = checkPermission(['tab_SingleReleaseHBL_tabSingleReleaseVerify'])
    this.hblSingleReleaseView = checkPermission(['tab_SingleReleaseHBL_tabSingleRelease'])
    if (this.singleReleaseVerifyView) {
      this.activeTabName = 'singleReleaseVerifyView'
    } else if (this.singleReleaseView) {
      this.activeTabName = 'singleReleaseView'
    } else if (this.singleReleaseVerifyViewHbl) {
      this.activeTabName = 'singleReleaseVerifyViewHbl'
    } else if (this.hblSingleReleaseView) {
      this.activeTabName = 'hblSingleReleaseView'
    }
    this.showView = !(!this.singleReleaseVerifyView && !this.singleReleaseView && !this.singleReleaseVerifyViewHbl && !this.hblSingleReleaseView)
  },
  methods: {
    setArWriteOffStatusQueryData() {
      console.log('主应用发送ArWriteOffStatusQuery:', this.arWriteOffStatusQuery)
      microApp.forceSetData('child-ar-WriteOffStatus-Query-ReleaseManagement', this.arWriteOffStatusQuery)
    },
    arWriteOffStatusQueryDataChange(e) {
      console.log('主应用获取ArWriteOffStatusQuery:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setArWriteOffStatusQueryData()
        } else {
          this.arWriteOffStatusQuerySearch = e.detail.data.searchItem
          this.arWriteOffStatusQueryColumn = e.detail.data.columnItem
        }
      }
    }
  }
}
</script>
